import {
  GlobeSelectedSvg,
  GlobeSvg,
  SchoolSelectedSvg,
  SchoolSvg,
} from "assets/images";
import { Loader } from "components";
import { useFilterLeaderboard } from "domain/hooks/filterLeaderboardHook";
import { FC, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getGameTypeFromLeaderBoardtype as getGameTypeFromLeaderBoardType,
  LeaderBoardType,
} from "screens/models/LeaderBoardType";
import { LeaderBoardResultList } from "../LeaderBoardResultList/LeaderBoardResultList";
import "./StudentOrTeacherTab.scss";

enum Tabs {
  ALL_CLASSROOMS,
  ALL_TEACHERS,
}

const TabButtonIconSize = "6vh";

interface Props {
  leaderBoardType: LeaderBoardType;
}

export const StudentOrTeacherTab: FC<Props> = (props) => {
  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState<Tabs>(Tabs.ALL_CLASSROOMS);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const ref = useRef<any>(null);

  const getRoomSource = (tab: Tabs) => {
    return tab === Tabs.ALL_CLASSROOMS ? "ClassRoom" : "Teacher";
  };

  const filterHook = useFilterLeaderboard({
    initialGameType: getGameTypeFromLeaderBoardType(props.leaderBoardType),
    initialSource: getRoomSource(selectedTab),
  });

  useEffect(() => {
    setHeight(ref?.current?.clientHeight ?? 0);
    setWidth(ref?.current?.clientWidth ?? 0);
  }, []);

  useEffect(() => {
    filterHook.actions.changeRoomSource(getRoomSource(selectedTab));
  }, [selectedTab, filterHook.actions]);

  const onSelectTab = (tab: Tabs) => {
    setSelectedTab(tab);
  };

  const getLogoForTab = (tab: Tabs) => {
    switch (tab) {
      case Tabs.ALL_CLASSROOMS:
        return selectedTab === Tabs.ALL_CLASSROOMS ? (
          <GlobeSelectedSvg
            width={TabButtonIconSize}
            height={TabButtonIconSize}
          />
        ) : (
          <GlobeSvg width={TabButtonIconSize} height={TabButtonIconSize} />
        );
      case Tabs.ALL_TEACHERS:
        return selectedTab === Tabs.ALL_TEACHERS ? (
          <SchoolSelectedSvg
            width={TabButtonIconSize}
            height={TabButtonIconSize}
          />
        ) : (
          <SchoolSvg width={TabButtonIconSize} height={TabButtonIconSize} />
        );
    }
  };

  const buttonForTab = (tab: Tabs) => {
    const titleLocaleKey =
      tab === Tabs.ALL_CLASSROOMS
        ? "roomType.allClassrooms"
        : "roomType.allTeachers";
    const sideClassName =
      tab === Tabs.ALL_CLASSROOMS ? "TabButtonLeft" : "TabButtonRight";

    return (
      <button
        className={`${sideClassName} ${
          tab === selectedTab ? "TabButtonSelected" : "TabButton"
        }`}
        onClick={() => onSelectTab(tab)}
      >
        <div className="TabButtonContent">
          <span className="TabButtonContentText">{t(titleLocaleKey)}</span>
          {getLogoForTab(tab)}
        </div>
      </button>
    );
  };

  return (
    <div className="TabsContainer">
      {filterHook.viewState.isLoading ? (
        <Loader isLoading={true} />
      ) : (
        <>
          <div className="TabSelectorRow">
            {buttonForTab(Tabs.ALL_CLASSROOMS)}
            {buttonForTab(Tabs.ALL_TEACHERS)}
          </div>
          <div className="StudentOrteacherTabContentContainer" ref={ref}>
            <LeaderBoardResultList
              tableHeight={height}
              tableWidth={width}
              leaderBoardType={props.leaderBoardType}
              data={filterHook.viewState.gameRecords}
              lastweeksWinner={filterHook.viewState.lastWeeksWinner}
            />
          </div>
        </>
      )}
    </div>
  );
};
